import { useContext } from 'react'
import { AuthContext, AuthContextValue } from '@/application/auth/contexts'

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within AuthContextProvider')
  }

  return context
}
